export enum ELandingFaqTermsAnimationDelay {
  TITLE = 0,
  LIST = 500,
}
